<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Döviz</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ara"
        single-line
        hide-details
      ></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="select"
        :items="items"
        item-value="id"
        item-text="value"
        hide-details
        label="Aktif/Pasif"
      ></v-combobox>
      <v-btn color="primary" dark @click="initialize" class="mb-2">Ara</v-btn>
      <!-- <v-btn color="primary" dark class="mb-2" to="/priceIncrease/detail">Yeni Ekle</v-btn> -->
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="this.$store.state.progress"
      :rows-per-page-items="pageItems"
      :items="this.$store.state.priceIncrease.all"
      :pagination.sync="pagination"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-0 text-xs-center"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <td class="px-0 text-xs-center">{{ props.item.id }}</td>
        <td class="px-0 text-xs-center">{{ props.item.price }}</td>
        <td class="px-0 text-xs-center">
          {{ props.item.startDate | formatDate }}
        </td>
        <td class="px-0 text-xs-center">
          {{ props.item.endDate | formatDate }}
        </td>
        <td class="px-0 text-xs-center">{{ props.item.startTime }}</td>
        <td class="px-0 text-xs-center">{{ props.item.endTime }}</td>
        <td class="px-0 text-xs-center" v-if="props.item.state == 1">Aktif</td>
        <td class="px-0 text-xs-center" v-else>Pasif</td>
        <td class="px-0 text-xs-center" style="max-width: 300px">
         <div v-if="props.item.productIds">{{ props.item.productIds.replaceAll(',',', ') }}</div>
        </td>

        <td class="px-0 text-xs-center">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  data: () => ({
    pagination: {
      sortBy: "name",
    },
    select: { id: -1, value: "Tümü" },
    search: null,
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    items: [
      { id: -1, value: "Tümü" },
      { id: false, value: "Pasif" },
      { id: true, value: "Aktif" },
    ],
    headers: [
      {
        text: "Id",
        align: "left",
        value: "id",
      },
      { text: "Fiyat", value: "price" },
      { text: "Başlangıç Tarihi", value: "startDate" },
      { text: "Bitiş Tarihi", value: "endDate" },
      { text: "Başlangıç Saati", value: "startTime" },
      { text: "Bitiş Saati", value: "endTime" },
      { text: "Durum", value: "state" },
      { text: "Ürünler", value: "productIds" },
        
      { text: "İşlem", value: "name", sortable: false },
    ],
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch("priceIncrease/searchPriceIncrease", {
        search: this.search,
        state: this.select.id,
      });
    },
    editItem(item) {
      this.$router.push({
        name: "priceIncrease-detail",
        params: { id: item.id },
      });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("priceIncrease/deletePriceIncrease", item);
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>
